import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import instance from "../../../config/Config"


const initialState = {
    loading: false,
    data: null, // don't do null any condition
    roleList: null, // don't do null any condition
    error: null,
    response: null,
    departmentData: null,
    pagesList: null
}

export const fetchRole = createAsyncThunk(
    "fetchRole",
    async () => {
        try {
            const res = await instance.get('/crm/role/fetch-all-role')
            return res.data
        } catch (error) {
            return error;
        }
    }
)

export const fetchDepartment = createAsyncThunk(
    "fetchDepartment",
    async () => {
        try {
            const res = await instance.get('/crm/role/fetch-department')
            return res.data
        } catch (error) {
            return error;
        }
    }
)
export const approvedRole = createAsyncThunk(
    "approvedRole",
    async () => {
        try {
            const res = await instance.get('/crm/role/approved-role')
            return res.data
        } catch (error) {
            return error;
        }
    }
)

export const updateRole = createAsyncThunk(
    "updateRole",
    async (body, { rejectWithValue }) => {
        try {
            const res = await instance.post(`/crm/role/update-role?id=${body.r_id}`, { r_pg_access: body.data })
            return res.data
        } catch (error) {
            return rejectWithValue(error);
        }
    }
)

export const createRole = createAsyncThunk(
    "createRole",
    async (body, { rejectWithValue }) => {
        try {
            const res = await instance.post('/crm/role/create-role', body)
            return res.data
        } catch (error) {
            return rejectWithValue(error);
        }
    }
)

export const fetchRoutePagesList = createAsyncThunk(
    "fetchRoutePagesList",
    async (body) => {
        try {
            const res = await instance.get(`/crm/route-pages/route-page-list?page=${body.page}`)
            return res.data
        } catch (error) {
            return error;
        }
    }
)
// export const fetchRoutePagesList = createAsyncThunk(
//     "fetchRoutePagesList",
//     async (body) => {
//         try {
//             const res = await instance.get(`/crm/route-pages/route-page-list?page=${body.page}`)
//             return res.data
//         } catch (error) {
//             return error;
//         }
//     }
// )
export const fetchAllRoutePagesList = createAsyncThunk(
    "fetchAllRoutePagesList",
    async () => {
        try {
            const res = await instance.get(`/crm/route-pages/route-page-list-all`)
            return res.data
        } catch (error) {
            return error;
        }
    }
)

export const createRoutePages = createAsyncThunk(
    "createRoutePages",
    async (body, { rejectWithValue }) => {
        try {
            const res = await instance.post('/crm/route-pages/create-route-page', body)
            return res.data
        } catch (error) {
            return rejectWithValue(error);
        }
    }
)
export const deleteRoutePages = createAsyncThunk(
    "deleteRoutePages",
    async (body, { rejectWithValue }) => {

        try {
            const res = await instance.post(
                `/crm/route-pages/deleted-page-list?id=${body.rp_id}`,
                {
                    rp_deleted_status: body.rp_deleted_status,
                }
            );
            return res.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);


export const updateRoutePages = createAsyncThunk(
    "updateRoutePages",
    async (body, { rejectWithValue }) => {
        try {
            const res = await instance.post(
                `/crm/route-pages/update-route-page?id=${body.rp_id}`,
                body
            );
            return res.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const RoleSlice = createSlice({
    name: 'RoleSlice',
    initialState,
    reducer: {},
    extraReducers:
        (builder) => {

            builder.addCase(fetchRole.pending, (state, action) => {
                state.loading = true
                state.data = null
                state.response = null;
            })
            builder.addCase(fetchRole.fulfilled, (state, action) => {
                state.loading = false
                state.data = action.payload
            })
            builder.addCase(fetchRole.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload?.data
            })

            builder.addCase(fetchDepartment.pending, (state, action) => {
                state.loading = false
            })
            builder.addCase(fetchDepartment.fulfilled, (state, action) => {
                state.loading = false
                state.departmentData = action.payload
            })
            builder.addCase(fetchDepartment.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload?.data
            })

            builder.addCase(approvedRole.pending, (state, action) => {
                state.loading = true
                state.response = null;
            })
            builder.addCase(approvedRole.fulfilled, (state, action) => {
                state.loading = false
                state.roleList = action.payload
            })
            builder.addCase(approvedRole.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload?.data
            })

            builder.addCase(updateRole.pending, (state, action) => {
                state.loading = false
                state.response = null;
            })
            builder.addCase(updateRole.fulfilled, (state, action) => {
                state.loading = false
                state.response = action.payload
            })
            builder.addCase(updateRole.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload?.data
            })

            builder.addCase(createRole.pending, (state, action) => {
                state.loading = false
                state.response = null;
            })
            builder.addCase(createRole.fulfilled, (state, action) => {
                state.loading = false
                state.response = action.payload
            })
            builder.addCase(createRole.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload?.data
            })
            builder.addCase(fetchRoutePagesList.pending, (state, action) => {
                state.loading = false
            })
            builder.addCase(fetchRoutePagesList.fulfilled, (state, action) => {
                state.loading = false
                state.pagesList = action.payload
            })
            builder.addCase(fetchRoutePagesList.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload?.data
            })
            builder.addCase(createRoutePages.pending, (state, action) => {
                state.loading = false
                state.response = null;
            })
            builder.addCase(createRoutePages.fulfilled, (state, action) => {
                state.loading = false
                state.response = action.payload
            })
            builder.addCase(createRoutePages.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload?.data
            })
            builder.addCase(deleteRoutePages.pending, (state, action) => {
                state.loading = false
                state.response = null;
            })
            builder.addCase(deleteRoutePages.fulfilled, (state, action) => {
                state.loading = false
                state.response = action.payload
            })
            builder.addCase(deleteRoutePages.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload?.data
            })


            builder.addCase(updateRoutePages.pending, (state, action) => {
                state.loading = false
                state.response = null;
            })
            builder.addCase(updateRoutePages.fulfilled, (state, action) => {
                state.loading = false
                state.response = action.payload
            })
            builder.addCase(updateRoutePages.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload?.data
            })

            builder.addCase(fetchAllRoutePagesList.pending, (state, action) => {
                state.loading = false
                state.response = null;
            })
            builder.addCase(fetchAllRoutePagesList.fulfilled, (state, action) => {
                state.loading = false
                state.response = action.payload
            })
            builder.addCase(fetchAllRoutePagesList.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload?.data
            })
        }
})


export default RoleSlice.reducer;
